import TrainingSlider from './TrainingSlider';

export default TrainingSlider;
